import React from 'react';
import PropTypes from 'prop-types';
import Button from './index';
import I18n from '../i18n';

const actionStyles = {
  save: {
    variant: 'success',
  },
  update: {
    icon: 'pencil-alt',
    variant: 'primary',
  },
  add: {
    icon: 'plus',
    variant: 'success',
  },
  new: {
    icon: 'plus',
    variant: 'success',
  },
  delete: {
    icon: 'trash-alt',
    variant: 'danger',
  },
  edit: {
    icon: 'pencil-alt',
    variant: 'primary',
  },
  import: {
    icon: 'download',
    variant: 'primary',
  },
};

export default function ResourceActionButton(props) {
  const {resource, action, ...rest} = props;

  return (
    <Button {...(actionStyles[action] || {})} {...rest}>
      <I18n t={`action.${action}-resource`} opts={{resource: I18n.t(resource)}} />
    </Button>
  );
}

ResourceActionButton.propTypes = {
  /** i18n key to the resource name */
  resource: PropTypes.string.isRequired,
  /** action to perform on this resource */
  action: PropTypes.string.isRequired,
};
